// src/data/customCocktails/stockOnly.js
// eslint-disable-next-line max-len
/** @type {import('../../types/cocktails').Cocktail[]} */
export const stockOnly = [
  {
    cocktail_id: 'sazerac',
    name: 'サゼラック',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1400,
    ingredients: [
      { name: 'ライウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'アブサン', amount: 5, unit: 'ml', required: false, notes: 'グラスをリンスする' },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true, notes: '砂糖キューブ1個' },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール', preparation: '香りづけのみ' }],
    glass: 'オールドファッショングラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: '伝統的なステアレシピ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ニューオーリンズスタイル',
    tasteTags: ['herbal', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'paper-plane',
    name: 'ペーパー・プレーン',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'バーボン', amount: 30, unit: 'ml', required: true },
      { name: 'アペロール', amount: 30, unit: 'ml', required: true },
      { name: 'アマーロ・ノニーノ', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンクラシック',
    tasteTags: ['bitter', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tom-collins',
    name: 'トムコリンズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true, notes: 'フレッシュ推奨' },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '炭酸以外をしっかり混ぜ、最後にソーダを追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックコレクション',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'cosmopolitan',
    name: 'コスモポリタン',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 40, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '90年代クラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'paloma',
    name: 'パロマ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 50, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true },
      { name: '塩', amount: null, unit: 'to_taste', required: false, notes: 'グラスのリムに塩を付ける' }
    ],
    garnish: [{ name: 'グレープフルーツウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'メキシカンスタイル',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'old-fashioned',
    name: 'オールドファッションド',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バーボン', amount: 60, unit: 'ml', required: true },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true },
      { name: 'ソーダ', amount: 10, unit: 'ml', required: false, notes: '砂糖を溶かすため少量' }
    ],
    garnish: [{ name: 'オレンジピール' }, { name: 'チェリー' }],
    glass: 'オールドファッショングラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build',
      restrictions: { no_shake: { reason: '伝統的にビルド or ステア' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ウイスキークラシック',
    tasteTags: ['rich', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'whiskey-sour',
    name: 'ウイスキーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワークラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mojito',
    name: 'モヒート',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '8-10枚をマドル' }
    ],
    garnish: [{ name: 'ミントの葉' }, { name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { muddle_first: { reason: 'ミントを軽くマドルしてから構築' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'キューバクラシック',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mai-tai',
    name: 'マイタイ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ラム', amount: 60, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }, { name: 'ミントの葉' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルクラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'between-the-sheets',
    name: 'ビトゥイーン・ザ・シーツ',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'ラム', amount: 30, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '禁酒法時代クラシック',
    tasteTags: ['citrus', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'boulevardier',
    name: 'ブールバーディエ',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: 'ネグローニのウイスキー版、透明感を保つ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'パリジャンクラシック',
    tasteTags: ['bitter', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'aperol-spritz',
    name: 'アペロール・スプリッツ',
    baseCategory: 'liqueurs',
    baseIngredient: 'アペロール',
    origin: 'イタリア',
    price: 900,
    ingredients: [
      { name: 'アペロール', amount: 60, unit: 'ml', required: true },
      { name: '白ワイン', amount: 90, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'イタリアンアペリティーヴォ',
    tasteTags: ['bitter', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'corpse-reviver-2',
    name: 'コープス・リヴァイヴァー No.2',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1200,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 30, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 30, unit: 'ml', required: true },
      { name: 'アブサン', amount: 2, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハングオーバーキュア',
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'french-75',
    name: 'フレンチ75',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: '白ワイン', amount: 60, unit: 'ml', required: true, notes: 'スパークリング推奨' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'シャンパングラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { wine_added_last: { reason: 'ワインは最後にグラスで追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'WWI時代クラシック',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rob-roy',
    name: 'ロブ・ロイ',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 20, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: 'マンハッタンのスコッチ版' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュクラシック',
    tasteTags: ['herbal', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-punch',
    name: 'ラムパンチ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }, { name: 'パイナップルピース' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'カリビアンスタイル',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'long-island-iced-tea',
    name: 'ロングアイランド・アイスティー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ウォッカ', amount: 15, unit: 'ml', required: true },
      { name: 'ジン', amount: 15, unit: 'ml', required: true },
      { name: 'ラム', amount: 15, unit: 'ml', required: true },
      { name: 'テキーラ', amount: 15, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'コーラ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { cola_added_last: { reason: 'コーラは最後にグラスで追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハイアルコールクラシック',
    tasteTags: ['strong', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sea-breeze',
    name: 'シーブリーズ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 90, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ビーチスタイル',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bay-breeze',
    name: 'ベイブリーズ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 90, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルスタイル',
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'madras',
    name: 'マドラス',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 60, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーティースタイル',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'godmother',
    name: 'ゴッドマザー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 25, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'シンプルクラシック',
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vesper',
    name: 'ヴェスパー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1200,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: 'ウォッカ', amount: 20, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'stir'],
      default: 'shake',
      restrictions: { bond_version: { reason: 'ジェームズ・ボンドは「シェイク、ステアではなく」' } }
    },
    isOnCurrentMenu: false,
    stockLabel: '007クラシック',
    tasteTags: ['strong', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'southside',
    name: 'サウスサイド',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '6-8枚をシェイク' }
    ],
    garnish: [{ name: 'ミントの葉' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { mint_in_shaker: { reason: 'ミントをシェーカーに入れてシェイク' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ギムレットのミント版',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'dark-and-stormy',
    name: 'ダークアンドストーミー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'バミューダ',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 50, unit: 'ml', required: true, notes: 'ダークラム推奨' },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'カリビアンスタイル',
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mint-julep',
    name: 'ミントジュレップ',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バーボン', amount: 60, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '8-10枚をマドル' },
      { name: 'ソーダ', amount: 10, unit: 'ml', required: false, notes: '少量' }
    ],
    garnish: [{ name: 'ミントの葉' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { muddle_mint: { reason: 'ミントを軽くマドルして香りを引き出す' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ケンタッキーダービークラシック',
    tasteTags: ['refreshing', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'amaretto-sour',
    name: 'アマレットサワー',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'アマレット', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'リキュールサワー',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bronx',
    name: 'ブロンクス',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレプロヒビション',
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'blood-and-sand',
    name: 'ブラッド・アンド・サンド',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'スコットランド',
    price: 1100,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '1920年代クラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'el-presidente',
    name: 'エル・プレジデンテ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1100,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 20, unit: 'ml', required: true },
      { name: 'オレンジキュラソー', amount: 10, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 5, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'キューバンクラシック',
    tasteTags: ['sweet', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'remember-the-maine',
    name: 'リメンバー・ザ・メイン',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ライウイスキー', amount: 60, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 20, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 10, unit: 'ml', required: true },
      { name: 'アブサン', amount: 2, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: '米西戦争クラシック',
    tasteTags: ['sweet', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-crusta',
    name: 'ブランデークラスタ',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ブランデー', amount: 50, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 10, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 5, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピールスパイラル' }],
    glass: 'ワイングラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ニューオーリンズ1850年代',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'horses-neck',
    name: 'ホーセズネック',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'レモンピールスパイラル' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックハイボール',
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'scofflaw',
    name: 'スコフロー',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ライウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '禁酒法時代',
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'caipiroska',
    name: 'カイピロスカ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'ブラジル',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'ライム', amount: null, unit: 'to_taste', required: true, notes: '1/2個をカット' },
      { name: '砂糖', amount: 2, unit: 'to_taste', required: true, notes: 'ティースプーン2杯' }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { muddle_lime: { reason: 'ライムと砂糖をマドルしてから氷を追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ブラジリアンスタイル',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'presbyterian',
    name: 'プレスビテリアン',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 800,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 60, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'シンプルハイボール',
    tasteTags: ['refreshing', 'spicy'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mamie-taylor',
    name: 'メイミーテイラー',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュハイボール',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'champagne-cocktail',
    name: 'シャンパンカクテル',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: '白ワイン', amount: 120, unit: 'ml', required: true, notes: 'スパークリング推奨' },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'シャンパングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { sugar_in_glass: { reason: '角砂糖にビターズを染み込ませてからワインを注ぐ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックシャンパン',
    tasteTags: ['refreshing', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'death-in-the-afternoon',
    name: 'デス・イン・ジ・アフタヌーン',
    baseCategory: 'spirits',
    baseIngredient: 'アブサン',
    origin: 'フランス',
    price: 1300,
    ingredients: [
      { name: 'アブサン', amount: 30, unit: 'ml', required: true },
      { name: '白ワイン', amount: 90, unit: 'ml', required: true, notes: 'スパークリング推奨' }
    ],
    garnish: [],
    glass: 'シャンパングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { absinthe_first: { reason: 'アブサンを先に入れてからシャンパンを注ぐ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ヘミングウェイクラシック',
    tasteTags: ['herbal', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ward-eight',
    name: 'ワード・エイト',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ライウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }, { name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ボストンクラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pegu-club',
    name: 'ペグクラブ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'ミャンマー',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジキュラソー', amount: 20, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'ライムピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'コロニアルクラシック',
    tasteTags: ['citrus', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'corpse-reviver-1',
    name: 'コープス・リヴァイヴァー No.1',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'アップルブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハングオーバーキュア',
    tasteTags: ['rich', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'satans-whiskers',
    name: 'サタンズウィスカーズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 20, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 10, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '1920年代ロンドン',
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'income-tax',
    name: 'インカムタックス',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 15, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '禁酒法時代',
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'perfect-manhattan',
    name: 'パーフェクトマンハッタン',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'チェリー' }, { name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: 'マンハッタンのパーフェクトバリエーション' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'マンハッタン変種',
    tasteTags: ['herbal', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'kir-royale',
    name: 'キールロワイヤル',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'フランス',
    price: 900,
    ingredients: [
      { name: '白ワイン', amount: 90, unit: 'ml', required: true, notes: 'スパークリング推奨' },
      { name: 'カシスリキュール', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'シャンパングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { cassis_first: { reason: 'カシスを先に入れてからワインを注ぐ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'フレンチアペリティフ',
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mimosa',
    name: 'ミモザ',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'フランス',
    price: 900,
    ingredients: [
      { name: '白ワイン', amount: 75, unit: 'ml', required: true, notes: 'スパークリング推奨' },
      { name: 'オレンジジュース', amount: 75, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'シャンパングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ブランチクラシック',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bees-knees',
    name: 'ビーズニーズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true, notes: 'ハニーシロップ' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_hard: { reason: 'ハチミツをしっかり混ぜるため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: '禁酒法時代',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gold-rush',
    name: 'ゴールドラッシュ',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バーボン', amount: 60, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true, notes: 'ハニーシロップ' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンクラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bramble',
    name: 'ブランブル',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 15, unit: 'ml', required: true, notes: 'クレームドカシスで代用' }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'ブラックベリー' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { cassis_drizzled: { reason: 'カシスは最後にドリズル' } }
    },
    isOnCurrentMenu: false,
    stockLabel: '1980年代ロンドン',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'highball',
    name: 'ハイボール',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: '日本',
    price: 800,
    ingredients: [
      { name: 'ウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { gentle_pour: { reason: '炭酸を保つため優しく注ぐ' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ジャパニーズスタイル',
    tasteTags: ['refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'singapore-sling',
    name: 'シンガポールスリング',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'シンガポール',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 15, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 10, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'パイナップルピース' }, { name: 'チェリー' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ラッフルズホテルクラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'naked-and-famous',
    name: 'ネイキッド・アンド・フェイマス',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'テキーラ', amount: 30, unit: 'ml', required: true },
      { name: 'アペロール', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 30, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンクラシック',
    tasteTags: ['citrus', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'southside-fizz',
    name: 'サウスサイドフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '6-8枚' },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ミントの葉' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { soda_added_last: { reason: 'ソーダは最後にグラスで追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'モヒートのジン版',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'clover-club',
    name: 'クローバークラブ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ラズベリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレプロヒビション',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'aviation-simplified',
    name: 'アビエーション（簡易版）',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ブルーキュラソー', amount: 10, unit: 'ml', required: true, notes: 'マラスキーノ代用' },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '簡易版クラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rusty-nail',
    name: 'ラスティネイル',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'スコットランド',
    price: 1000,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 20, unit: 'ml', required: true, notes: 'ドランブイ代用' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュクラシック',
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mexican-mule',
    name: 'メキシカンミュール',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'マグカップ',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モスコミュールのテキーラ版',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'havana-beach',
    name: 'ハバナビーチ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }, { name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルクラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-collins',
    name: 'ウォッカコリンズ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トムコリンズ変種',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-collins',
    name: 'テキーラコリンズ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トムコリンズ変種',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-old-fashioned',
    name: 'ラムオールドファッションド',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 60, unit: 'ml', required: true, notes: 'ダークラム推奨' },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'オールドファッションド変種',
    tasteTags: ['rich', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-alexander-dry',
    name: 'ブランデーアレキサンダー（ドライ）',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 40, unit: 'ml', required: true },
      { name: 'アマレット', amount: 30, unit: 'ml', required: true, notes: 'クレームドカカオ代用' },
      { name: 'オレンジジュース', amount: 20, unit: 'ml', required: true, notes: 'クリーム代用' }
    ],
    garnish: [{ name: 'ナツメグ' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '簡易版クラシック',
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-buck',
    name: 'ジンバック',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-buck',
    name: 'ウォッカバック',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-buck',
    name: 'テキーラバック',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-buck',
    name: 'ブランデーバック',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ブランデー', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'peach-fizz',
    name: 'ピーチフィズ',
    baseCategory: 'liqueurs',
    baseIngredient: 'ピーチリキュール',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ピーチリキュール', amount: 40, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーツフィズ',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bacardi-cocktail',
    name: 'バカルディ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true, notes: 'バカルディ推奨' },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'キューバンクラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'amaretto-orange',
    name: 'アマレットオレンジ',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'イタリア',
    price: 850,
    ingredients: [
      { name: 'アマレット', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'シンプルリキュール',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'dirty-martini',
    name: 'ダーティマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 10, unit: 'ml', required: true },
      { name: 'オリーブ', amount: null, unit: 'to_taste', required: true, notes: 'オリーブブライン（オリーブ汁）10ml' }
    ],
    garnish: [{ name: 'オリーブ' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マティーニ変種',
    tasteTags: ['umami', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'fifty-fifty',
    name: 'フィフティ・フィフティ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 35, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 35, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マティーニ変種',
    tasteTags: ['herbal', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gibson',
    name: 'ギブソン',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'カクテルオニオン' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マティーニ変種',
    tasteTags: ['herbal', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'fino-martini',
    name: 'フィノマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'スペイン',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マティーニ変種',
    tasteTags: ['herbal', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tuxedo',
    name: 'タキシード',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 40, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジキュラソー', amount: 5, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'チェリー' }, { name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'エレガントクラシック',
    tasteTags: ['herbal', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'blood-orange-negroni',
    name: 'ブラッドオレンジネグローニ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イタリア',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ネグローニ変種',
    tasteTags: ['bitter', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'boulevardier-perfect',
    name: 'パーフェクトブールバーディエ',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ブールバーディエ変種',
    tasteTags: ['bitter', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'porn-star-martini-simplified',
    name: 'パッションマティーニ（簡易版）',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 40, unit: 'ml', required: true, notes: 'パッションフルーツ代用' },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンクラシック簡易版',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'espresso-martini-substitute',
    name: 'コーヒーマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'アマレット', amount: 20, unit: 'ml', required: true, notes: 'カルーア代用' },
      { name: 'コーラ', amount: 20, unit: 'ml', required: true, notes: 'エスプレッソ代用' },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '簡易版モダン',
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'honey-deuce',
    name: 'ハニーデュース',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 40, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true, notes: 'ハニーシロップ' },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ラズベリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'USオープンテニス',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pink-lady',
    name: 'ピンクレディ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックピンク',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'honeymoon',
    name: 'ハネムーン',
    baseCategory: 'spirits',
    baseIngredient: 'アップルブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'アップルブランデー', amount: 40, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 20, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ロマンティッククラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'charlie-chaplin',
    name: 'チャーリーチャップリン',
    baseCategory: 'spirits',
    baseIngredient: 'アップルブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'アップルブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '映画スタークラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'zombie-simplified',
    name: 'ゾンビ（簡易版）',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'アップルブランデー', amount: 15, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 40, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ミントの葉' }, { name: 'パイナップルピース' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ティキクラシック',
    tasteTags: ['sweet', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'japanese-cocktail',
    name: 'ジャパニーズカクテル',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: '日本',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 60, unit: 'ml', required: true },
      { name: 'アマレット', amount: 10, unit: 'ml', required: true, notes: 'オルジェ代用' },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: '19世紀クラシック',
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tipperary',
    name: 'ティペラリー',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アイルランド',
    price: 1100,
    ingredients: [
      { name: 'ウイスキー', amount: 45, unit: 'ml', required: true, notes: 'アイリッシュ推奨' },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'アイリッシュクラシック',
    tasteTags: ['bitter', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'greenpoint',
    name: 'グリーンポイント',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ライウイスキー', amount: 60, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 15, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ブルックリンスタイル',
    tasteTags: ['bitter', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vieux-carre',
    name: 'ヴュー・カレ',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1300,
    ingredients: [
      { name: 'ライウイスキー', amount: 30, unit: 'ml', required: true },
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 10, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ニューオーリンズクラシック',
    tasteTags: ['complex', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bamboo',
    name: 'バンブー',
    baseCategory: 'liqueurs',
    baseIngredient: 'ドライベルモット',
    origin: '日本',
    price: 900,
    ingredients: [
      { name: 'ドライベルモット', amount: 45, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 45, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: '横浜クラシック',
    tasteTags: ['herbal', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'adonis',
    name: 'アドニス',
    baseCategory: 'liqueurs',
    baseIngredient: 'スイートベルモット',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'スイートベルモット', amount: 45, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 45, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ロウアルコールクラシック',
    tasteTags: ['herbal', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sherry-cobbler-substitute',
    name: 'シェリーコブラー（代用版）',
    baseCategory: 'liqueurs',
    baseIngredient: 'スイートベルモット',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'スイートベルモット', amount: 90, unit: 'ml', required: true, notes: 'シェリー代用' },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }, { name: 'ミントの葉' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: '19世紀アメリカン',
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-old-fashioned',
    name: 'テキーラオールドファッションド',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 60, unit: 'ml', required: true },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'アガベクラシック',
    tasteTags: ['rich', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-old-fashioned',
    name: 'ジンオールドファッションド',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: '角砂糖', amount: 1, unit: 'to_taste', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ジュニパークラシック',
    tasteTags: ['herbal', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-martini',
    name: 'ウォッカマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 60, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir', 'shake'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ロシアンスタイル',
    tasteTags: ['strong', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'orange-blossom',
    name: 'オレンジブロッサム',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 45, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 5, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレプロヒビション',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'fallen-angel',
    name: 'フォーレンエンジェル',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'ミントの葉' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '1920年代クラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'last-word-substitute',
    name: 'ラストワード（簡易版）',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 30, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '5-6枚をシェイク' }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '簡易版プロヒビション',
    tasteTags: ['herbal', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'honeysuckle',
    name: 'ハニーサックル',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true, notes: 'ハニーシロップ' }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'penicillin',
    name: 'ペニシリン',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 60, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 20, unit: 'ml', required: true, notes: 'ハニーシロップ' },
      { name: 'ジンジャーエール', amount: 15, unit: 'ml', required: true, notes: 'ジンジャー風味用' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンクラシック',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'new-york-sour',
    name: 'ニューヨークサワー',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バーボン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: '赤ワイン', amount: 15, unit: 'ml', required: true, notes: 'フロート' }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { wine_float: { reason: 'ワインは最後にフロート' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'アメリカンクラシック',
    tasteTags: ['citrus', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'naked-lady',
    name: 'ネイキッドレディ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 20, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルクラシック',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'hemingway-daiquiri',
    name: 'ヘミングウェイダイキリ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1100,
    ingredients: [
      { name: 'ラム', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 5, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ヘミングウェイスタイル',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'twentieth-century',
    name: '20世紀',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ホワイトキュラソー', amount: 20, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'カカオ', amount: 15, unit: 'ml', required: false, notes: 'リレブラン代用にアマレット可' }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'アールデコクラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bramble-royale',
    name: 'ブランブルロワイヤル',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 40, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 15, unit: 'ml', required: true },
      { name: '白ワイン', amount: 30, unit: 'ml', required: true, notes: 'スパークリング推奨' }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンブリティッシュ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-sour',
    name: 'テキーラサワー',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-sour',
    name: 'ブランデーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'ブランデー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-sour',
    name: 'ラムサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pisco-sour-substitute',
    name: 'ピスコサワー（代用版）',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'ペルー',
    price: 1000,
    ingredients: [
      { name: 'ブランデー', amount: 60, unit: 'ml', required: true, notes: 'ピスコ代用' },
      { name: 'ライムジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 20, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: false }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: '南米クラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'suffering-bastard',
    name: 'サファリングバスタード',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'エジプト',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 90, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }, { name: 'ミントの葉' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'エキゾチッククラシック',
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-daisy',
    name: 'ジンデイジー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { soda_added_last: { reason: 'ソーダは最後に追加' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'デイジーシリーズ',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-daisy',
    name: 'ウォッカデイジー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'デイジーシリーズ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-daisy',
    name: 'ラムデイジー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'デイジーシリーズ',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-daisy',
    name: 'ブランデーデイジー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'デイジーシリーズ',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'stone-fence',
    name: 'ストーンフェンス',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 850,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'アメリカンコロニアル',
    tasteTags: ['refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'presbyterian-perfect',
    name: 'パーフェクトプレスビテリアン',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 850,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 60, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレスビテリアン変種',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-buck',
    name: 'ラムバック',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'scotch-buck',
    name: 'スコッチバック',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'スコットランド',
    price: 950,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'バックシリーズ',
    tasteTags: ['spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'espresso-martini-cola',
    name: 'コーラマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: '創作',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'コーラ', amount: 30, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クリエイティブ',
    tasteTags: ['sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-sour',
    name: 'ジンサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-sour',
    name: 'ウォッカサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'scotch-sour',
    name: 'スコッチサワー',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'スコットランド',
    price: 1000,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }, { name: 'チェリー' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'サワーシリーズ',
    tasteTags: ['citrus', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pineapple-margarita',
    name: 'パイナップルマルガリータ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 20, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'マルガリータグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルマルガリータ',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'raspberry-martini-substitute',
    name: 'ラズベリーマティーニ（代用版）',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 20, unit: 'ml', required: true, notes: 'ラズベリー代用' },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーツマティーニ',
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'elderflower-collins-substitute',
    name: 'エルダーフラワーコリンズ（代用版）',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライチリキュール', amount: 15, unit: 'ml', required: true, notes: 'エルダーフラワー代用' },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フローラルクラシック',
    tasteTags: ['floral', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'jungle-bird-simplified',
    name: 'ジャングルバード（簡易版）',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'マレーシア',
    price: 1100,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 20, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ティキビター',
    tasteTags: ['bitter', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tommy-margarita',
    name: 'トミーズマルガリータ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 30, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true, notes: 'アガベシロップ代用' }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マルガリータ変種',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-honey-sour',
    name: 'ジンハニーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: '創作',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-honey-sour',
    name: 'ウォッカハニーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: '創作',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-honey-sour',
    name: 'テキーラハニーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 25, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-honey-sour',
    name: 'ブランデーハニーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-honey-sour',
    name: 'ラムハニーサワー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 50, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 25, unit: 'ml', required: true },
      { name: 'ハチミツ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムホイール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハニーサワー',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'japanese-slipper-substitute',
    name: 'ジャパニーズスリッパー（代用版）',
    baseCategory: 'liqueurs',
    baseIngredient: 'ライチリキュール',
    origin: 'オーストラリア',
    price: 900,
    ingredients: [
      { name: 'ライチリキュール', amount: 30, unit: 'ml', required: true, notes: 'メロン代用' },
      { name: 'コアントロー', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'オセアニアクラシック',
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'french-martini-substitute',
    name: 'フレンチマティーニ（代用版）',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 15, unit: 'ml', required: true, notes: 'シャンボール代用' },
      { name: 'パイナップルジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フレンチモダン',
    tasteTags: ['sweet', 'fruity'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'cucumber-cooler',
    name: 'キュウリクーラー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: '創作',
    price: 950,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }, { name: 'ミントの葉' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'リフレッシングクーラー',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ginger-smash',
    name: 'ジンジャースマッシュ',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 30, unit: 'ml', required: true, notes: 'ジンジャー風味用' },
      { name: 'ミント', amount: null, unit: 'to_taste', required: true, notes: '6-8枚をマドル' }
    ],
    garnish: [{ name: 'ミントの葉' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { muddle_mint: { reason: 'ミントをマドルしてから構築' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'スマッシュシリーズ',
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-cooler',
    name: 'ラムクーラー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'カリブ海',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }, { name: 'ミントの葉' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クーラーシリーズ',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vodka-cooler',
    name: 'ウォッカクーラー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 850,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クーラーシリーズ',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-cooler',
    name: 'テキーラクーラー',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クーラーシリーズ',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-cooler',
    name: 'ブランデークーラー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'ブランデー', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クーラーシリーズ',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'whiskey-cooler',
    name: 'ウイスキークーラー',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クーラーシリーズ',
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'orange-vodka-crush',
    name: 'オレンジウォッカクラッシュ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: '創作',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーツクラッシュ',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pineapple-vodka-crush',
    name: 'パイナップルウォッカクラッシュ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: '創作',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 90, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーツクラッシュ',
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'cranberry-vodka-crush',
    name: 'クランベリーウォッカクラッシュ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: '創作',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 90, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーツクラッシュ',
    tasteTags: ['tart', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'grapefruit-gin-fizz',
    name: 'グレープフルーツジンフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 950,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'グレープフルーツスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フィズバリエーション',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'orange-gin-fizz',
    name: 'オレンジジンフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 950,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フィズバリエーション',
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rusty-nail',
    name: 'ラスティネイル',
    baseCategory: 'liqueurs',
    baseIngredient: 'ドランブイ',
    origin: 'スコットランド',
    price: 1100,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'ドランブイ', amount: 25, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンツイスト' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュクラシック',
    tasteTags: ['rich', 'sweet', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'drambuie-mist',
    name: 'ドランブイミスト',
    baseCategory: 'liqueurs',
    baseIngredient: 'ドランブイ',
    origin: 'スコットランド',
    price: 1000,
    ingredients: [
      { name: 'ドランブイ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンツイスト' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: 'クラッシュアイスで冷やすため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュリキュール',
    tasteTags: ['rich', 'sweet', 'honey'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'blue-lagoon',
    name: 'ブルーラグーン',
    baseCategory: 'liqueurs',
    baseIngredient: 'ブルーキュラソー',
    origin: 'フランス',
    price: 950,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'ブルーキュラソー', amount: 20, unit: 'ml', required: true },
      { name: 'レモネード', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build', 'shake'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルブルー',
    tasteTags: ['refreshing', 'citrus', 'tropical'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'blue-hawaii',
    name: 'ブルーハワイ',
    baseCategory: 'liqueurs',
    baseIngredient: 'ブルーキュラソー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 30, unit: 'ml', required: true },
      { name: 'ブルーキュラソー', amount: 15, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 60, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'パイナップルチャンク', notes: 'チェリー添え' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'blend'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルクラシック',
    tasteTags: ['tropical', 'sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'apple-martini',
    name: 'アップルマティーニ',
    baseCategory: 'liqueurs',
    baseIngredient: 'グリーンアップルリキュール',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'グリーンアップルリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'アップルスライス' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '冷却と材料の混合のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'フレッシュアップル',
    tasteTags: ['sweet', 'fruity', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sour-apple',
    name: 'サワーアップル',
    baseCategory: 'liqueurs',
    baseIngredient: 'グリーンアップルリキュール',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'グリーンアップルリキュール', amount: 45, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'アップルスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'アップルフィズ',
    tasteTags: ['refreshing', 'fruity', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'grasshopper',
    name: 'グラスホッパー',
    baseCategory: 'liqueurs',
    baseIngredient: 'ホワイトカカオリキュール',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'グリーンミントリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームと材料の乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'デザートカクテル',
    tasteTags: ['sweet', 'creamy', 'mint'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'golden-cadillac',
    name: 'ゴールデンキャデラック',
    baseCategory: 'liqueurs',
    baseIngredient: 'ホワイトカカオリキュール',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ガリアーノ', amount: 20, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'リッチデザート',
    tasteTags: ['sweet', 'creamy', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'parfait-amour-fizz',
    name: 'パルフェタムールフィズ',
    baseCategory: 'liqueurs',
    baseIngredient: 'パルフェタムール',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'パルフェタムール', amount: 30, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: false },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フローラルフィズ',
    tasteTags: ['floral', 'citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'purple-rain',
    name: 'パープルレイン',
    baseCategory: 'liqueurs',
    baseIngredient: 'パルフェタムール',
    origin: 'アメリカ',
    price: 950,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'パルフェタムール', amount: 15, unit: 'ml', required: true },
      { name: 'クランベリージュース', amount: 60, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'build'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルパープル',
    tasteTags: ['fruity', 'sweet', 'tropical'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ichiros-highball',
    name: 'イチローズハイボール',
    baseCategory: 'spirits',
    baseIngredient: 'イチローズモルト',
    origin: '日本',
    price: 1200,
    ingredients: [
      { name: 'イチローズモルト', amount: 45, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '炭酸を損なわないため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレミアムハイボール',
    tasteTags: ['refreshing', 'crisp', 'malty'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ichiros-malt-rocks',
    name: 'イチローズモルトロック',
    baseCategory: 'spirits',
    baseIngredient: 'イチローズモルト',
    origin: '日本',
    price: 1500,
    ingredients: [
      { name: 'イチローズモルト', amount: 45, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレミアムウイスキー',
    tasteTags: ['rich', 'complex', 'malty'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ichiros-malt-mizuwari',
    name: 'イチローズモルト水割り',
    baseCategory: 'spirits',
    baseIngredient: 'イチローズモルト',
    origin: '日本',
    price: 1200,
    ingredients: [
      { name: 'イチローズモルト', amount: 45, unit: 'ml', required: true },
      { name: 'ミネラルウォーター', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'プレミアム水割り',
    tasteTags: ['smooth', 'malty', 'mellow'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'brandy-alexander',
    name: 'ブランデーアレキサンダー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'ダークカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ナツメグパウダー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックデザート',
    tasteTags: ['sweet', 'creamy', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'alexander',
    name: 'アレキサンダー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ナツメグパウダー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クリーミークラシック',
    tasteTags: ['sweet', 'creamy', 'smooth'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'white-russian',
    name: 'ホワイトルシアン',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'ベルギー',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 40, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'shake'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'コーヒーデザート',
    tasteTags: ['sweet', 'creamy', 'coffee'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'black-russian',
    name: 'ブラックルシアン',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'ベルギー',
    price: 950,
    ingredients: [
      { name: 'ウォッカ', amount: 40, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'コーヒーカクテル',
    tasteTags: ['sweet', 'coffee', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mudslide',
    name: 'マッドスライド',
    baseCategory: 'liqueurs',
    baseIngredient: 'コーヒーリキュール',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'アイリッシュクリーム', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チョコレートシロップ', notes: 'グラスの内側に' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'blend'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'リッチコーヒー',
    tasteTags: ['sweet', 'creamy', 'coffee'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'b52',
    name: 'B52',
    baseCategory: 'liqueurs',
    baseIngredient: 'コーヒーリキュール',
    origin: 'カナダ',
    price: 1000,
    ingredients: [
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'アイリッシュクリーム', amount: 20, unit: 'ml', required: true },
      { name: 'グランマルニエ', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ショットグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '層状に注ぐため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'レイヤードショット',
    tasteTags: ['sweet', 'coffee', 'layered'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'angel-kiss',
    name: 'エンジェルキス',
    baseCategory: 'liqueurs',
    baseIngredient: 'ダークカカオリキュール',
    origin: 'フランス',
    price: 950,
    ingredients: [
      { name: 'ダークカカオリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'リキュールグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '層状に注ぐため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'レイヤードデザート',
    tasteTags: ['sweet', 'creamy', 'chocolate'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pink-squirrel',
    name: 'ピンクスクワール',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'アマレット', amount: 20, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 30, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ピンクデザート',
    tasteTags: ['sweet', 'creamy', 'nutty'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pina-colada',
    name: 'ピニャコラーダ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'プエルトリコ',
    price: 1100,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ココナッツクリーム', amount: 30, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルチャンク', notes: 'チェリー添え' }],
    glass: 'タンブラー',
    method: 'blend',
    methodRules: {
      allowed: ['blend', 'shake'],
      default: 'blend'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルクリーミー',
    tasteTags: ['sweet', 'creamy', 'tropical'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'chi-chi',
    name: 'チチ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'ココナッツクリーム', amount: 30, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルウェッジ' }],
    glass: 'タンブラー',
    method: 'blend',
    methodRules: {
      allowed: ['blend', 'shake'],
      default: 'blend'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルスムーズ',
    tasteTags: ['sweet', 'creamy', 'tropical'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bushwacker',
    name: 'ブッシュワッカー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ラム', amount: 30, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'ダークカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'ココナッツクリーム', amount: 30, unit: 'ml', required: true },
      { name: 'ミルク', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チョコレートシェービング' }],
    glass: 'タンブラー',
    method: 'blend',
    methodRules: {
      allowed: ['blend', 'shake'],
      default: 'blend'
    },
    isOnCurrentMenu: false,
    stockLabel: 'デカダントデザート',
    tasteTags: ['sweet', 'creamy', 'chocolate', 'coffee'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'panama',
    name: 'パナマ',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ナツメグパウダー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'エレガントデザート',
    tasteTags: ['sweet', 'creamy', 'elegant'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'velvet-hammer',
    name: 'ベルベットハンマー',
    baseCategory: 'liqueurs',
    baseIngredient: 'コアントロー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 20, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 20, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ベルベットスムーズ',
    tasteTags: ['sweet', 'creamy', 'smooth'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'toasted-almond',
    name: 'トーステッドアーモンド',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'アマレット', amount: 30, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'クリーム', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'build'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ナッツコーヒー',
    tasteTags: ['sweet', 'creamy', 'nutty', 'coffee'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'orgasm',
    name: 'オーガズム',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'アマレット', amount: 20, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'アイリッシュクリーム', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'デカダントクリーム',
    tasteTags: ['sweet', 'creamy', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'screaming-orgasm',
    name: 'スクリーミングオーガズム',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ウォッカ', amount: 20, unit: 'ml', required: true },
      { name: 'アマレット', amount: 20, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'アイリッシュクリーム', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'エクストラリッチ',
    tasteTags: ['sweet', 'creamy', 'rich', 'coffee'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'slippery-nipple',
    name: 'スリッパリーニップル',
    baseCategory: 'liqueurs',
    baseIngredient: 'アイリッシュクリーム',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'サンブーカ', amount: 30, unit: 'ml', required: true },
      { name: 'アイリッシュクリーム', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ショットグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '層状に注ぐため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'レイヤードショット',
    tasteTags: ['sweet', 'creamy', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'banshee',
    name: 'バンシー',
    baseCategory: 'liqueurs',
    baseIngredient: 'ホワイトカカオリキュール',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バナナリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'ホワイトカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'バナナデザート',
    tasteTags: ['sweet', 'creamy', 'fruity'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'chocolate-covered-banana',
    name: 'チョコレートカバードバナナ',
    baseCategory: 'liqueurs',
    baseIngredient: 'バナナリキュール',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'バナナリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'ダークカカオリキュール', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チョコレートシェービング' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クリームの乳化のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'チョコバナナ',
    tasteTags: ['sweet', 'creamy', 'chocolate', 'fruity'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'aviation',
    name: 'アビエーション',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'マラスキーノリキュール', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'バイオレットリキュール', amount: 10, unit: 'ml', required: false, notes: '紫色を出すため' }
    ],
    garnish: [{ name: 'マラスキーノチェリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '冷却と混合のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックフローラル',
    tasteTags: ['floral', 'citrus', 'elegant'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'last-word',
    name: 'ラストワード',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 22, unit: 'ml', required: true },
      { name: 'グリーンシャルトリューズ', amount: 22, unit: 'ml', required: true },
      { name: 'マラスキーノリキュール', amount: 22, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 22, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'バランスを取るため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ハーバルクラシック',
    tasteTags: ['herbal', 'citrus', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'corpse-reviver-2',
    name: 'コープスリバイバー2',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 22, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 22, unit: 'ml', required: true },
      { name: 'リレブラン', amount: 22, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 22, unit: 'ml', required: true },
      { name: 'アブサン', amount: 1, unit: 'dash', required: false }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'しっかり混ぜるため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'モーニングリバイバル',
    tasteTags: ['refreshing', 'citrus', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ramos-gin-fizz',
    name: 'ラモスジンフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 20, unit: 'ml', required: true },
      { name: 'クリーム', amount: 30, unit: 'ml', required: true },
      { name: '卵白', amount: 1, unit: '個', required: true },
      { name: 'オレンジフラワーウォーター', amount: 3, unit: 'drops', required: false },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '卵白の泡立てのため長時間シェイク必要' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クリーミーフィズ',
    tasteTags: ['creamy', 'citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vesper',
    name: 'ヴェスパー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1200,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: 'ウォッカ', amount: 20, unit: 'ml', required: true },
      { name: 'リレブラン', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'stir'],
      default: 'shake',
      restrictions: { note: 'ジェームズ・ボンド流はシェイク' }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ボンドマティーニ',
    tasteTags: ['dry', 'strong', 'elegant'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'hanky-panky',
    name: 'ハンキーパンキー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 45, unit: 'ml', required: true },
      { name: 'フェルネットブランカ', amount: 7, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: 'クリアに仕上げるため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ビタースイート',
    tasteTags: ['bitter', 'herbal', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'boulevardier',
    name: 'ブールヴァルディエ',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'フランス',
    price: 1200,
    ingredients: [
      { name: 'バーボンウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir', 'build'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ビタースイート',
    tasteTags: ['bitter', 'rich', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sazerac',
    name: 'サゼラック',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 1300,
    ingredients: [
      { name: 'ライウイスキー', amount: 60, unit: 'ml', required: true },
      { name: 'アブサン', amount: 5, unit: 'ml', required: true, notes: 'グラスリンス用' },
      { name: '砂糖', amount: 1, unit: 'cube', required: true },
      { name: 'ペイショーズビターズ', amount: 3, unit: 'dashes', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: 'アブサンリンスとステア技法のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'ニューオーリンズクラシック',
    tasteTags: ['strong', 'herbal', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'vieux-carre',
    name: 'ヴューカレ',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 1300,
    ingredients: [
      { name: 'ライウイスキー', amount: 30, unit: 'ml', required: true },
      { name: 'コニャック', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'ベネディクティン', amount: 5, unit: 'ml', required: true },
      { name: 'ペイショーズビターズ', amount: 2, unit: 'dashes', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dashes', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: false,
    stockLabel: 'コンプレックスクラシック',
    tasteTags: ['rich', 'complex', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'blood-and-sand',
    name: 'ブラッドアンドサンド',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'スコットランド',
    price: 1100,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 22, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 22, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 22, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 22, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコティッシュフルーティー',
    tasteTags: ['fruity', 'sweet', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'penicillin',
    name: 'ペニシリン',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'アメリカ',
    price: 1200,
    ingredients: [
      { name: 'ブレンデッドスコッチ', amount: 60, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 22, unit: 'ml', required: true },
      { name: 'ハニーシロップ', amount: 22, unit: 'ml', required: true },
      { name: 'ジンジャーシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'アイラウイスキー', amount: 7, unit: 'ml', required: true, notes: 'フロート用' }
    ],
    garnish: [{ name: 'キャンディジンジャー' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンスコッチ',
    tasteTags: ['smoky', 'spicy', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tommy-margarita',
    name: 'トミーズマルガリータ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 30, unit: 'ml', required: true },
      { name: 'アガベシロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ピュアマルガリータ',
    tasteTags: ['citrus', 'refreshing', 'agave'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'paloma',
    name: 'パロマ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 60, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 90, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 30, unit: 'ml', required: true },
      { name: '塩', amount: 1, unit: 'pinch', required: false }
    ],
    garnish: [{ name: 'グレープフルーツウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build', 'shake'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'メキシカンリフレッシュ',
    tasteTags: ['refreshing', 'citrus', 'salty'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-sunrise',
    name: 'テキーラサンライズ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 950,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス', notes: 'チェリー添え' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: 'グラデーション効果のため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'サンライズカラー',
    tasteTags: ['sweet', 'fruity', 'colorful'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'mexican-mule',
    name: 'メキシカンミュール',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャービア', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'コッパーマグ',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スパイシーミュール',
    tasteTags: ['spicy', 'refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'hemingway-daiquiri',
    name: 'ヘミングウェイダイキリ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1100,
    ingredients: [
      { name: 'ホワイトラム', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 15, unit: 'ml', required: true },
      { name: 'マラスキーノリキュール', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'blend'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ライタースダイキリ',
    tasteTags: ['citrus', 'dry', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'jungle-bird',
    name: 'ジャングルバード',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'マレーシア',
    price: 1100,
    ingredients: [
      { name: 'ダークラム', amount: 45, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 22, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルウェッジ' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'build'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルビター',
    tasteTags: ['tropical', 'bitter', 'complex'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'painkiller',
    name: 'ペインキラー',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'イギリス領バージン諸島',
    price: 1100,
    ingredients: [
      { name: 'ダークラム', amount: 60, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 120, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 30, unit: 'ml', required: true },
      { name: 'ココナッツクリーム', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ナツメグパウダー', notes: 'パイナップルウェッジ添え' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'blend'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルパワー',
    tasteTags: ['tropical', 'creamy', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'ti-punch',
    name: 'ティパンチ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'マルティニーク',
    price: 900,
    ingredients: [
      { name: 'アグリコールラム', amount: 60, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ケインシュガーシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムディスク' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'マルティニークスタイル',
    tasteTags: ['strong', 'citrus', 'grassy'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'espresso-martini',
    name: 'エスプレッソマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'イギリス',
    price: 1100,
    ingredients: [
      { name: 'ウォッカ', amount: 50, unit: 'ml', required: true },
      { name: 'コーヒーリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'エスプレッソ', amount: 30, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'コーヒービーン', notes: '3粒' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: 'クレマ（泡）を作るため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'モダンコーヒー',
    tasteTags: ['coffee', 'rich', 'bitter'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'lemon-drop-martini',
    name: 'レモンドロップマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 20, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'シュガーリム', notes: 'レモンツイスト添え' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スイートサワー',
    tasteTags: ['citrus', 'sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'french-martini',
    name: 'フレンチマティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'シャンボールリキュール', amount: 15, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 45, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ラズベリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'フルーティーエレガント',
    tasteTags: ['fruity', 'sweet', 'elegant'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bramble',
    name: 'ブランブル',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 50, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 25, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 12, unit: 'ml', required: true },
      { name: 'クレームドミュール', amount: 15, unit: 'ml', required: true, notes: 'フロート用' }
    ],
    garnish: [{ name: 'ブラックベリー', notes: 'レモンスライス添え' }],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ベリーシトラス',
    tasteTags: ['fruity', 'citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'clover-club',
    name: 'クローバークラブ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ラズベリーシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 15, unit: 'ml', required: true },
      { name: '卵白', amount: 1, unit: '個', required: true }
    ],
    garnish: [{ name: 'ラズベリー' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '卵白の泡立てのため' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックベリー',
    tasteTags: ['fruity', 'citrus', 'silky'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'singapore-sling',
    name: 'シンガポールスリング',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'シンガポール',
    price: 1200,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 15, unit: 'ml', required: true },
      { name: 'ベネディクティン', amount: 7, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 7, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 120, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 10, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 1, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'パイナップルスライス', notes: 'チェリー添え' }],
    glass: 'タンブラー',
    method: 'shake',
    methodRules: {
      allowed: ['shake', 'build'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'トロピカルコンプレックス',
    tasteTags: ['tropical', 'complex', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'amaretto-sour',
    name: 'アマレットサワー',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'アメリカ',
    price: 950,
    ingredients: [
      { name: 'アマレット', amount: 45, unit: 'ml', required: true },
      { name: 'バーボンウイスキー', amount: 22, unit: 'ml', required: false },
      { name: 'レモンジュース', amount: 30, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 15, unit: 'ml', required: true },
      { name: '卵白', amount: 1, unit: '個', required: false }
    ],
    garnish: [{ name: 'レモンスライス', notes: 'チェリー添え' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ナッツサワー',
    tasteTags: ['nutty', 'citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'midori-sour',
    name: 'ミドリサワー',
    baseCategory: 'liqueurs',
    baseIngredient: 'メロンリキュール',
    origin: '日本',
    price: 900,
    ingredients: [
      { name: 'メロンリキュール', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true },
      { name: 'シンプルシロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'メロンボール' }],
    glass: 'ロックグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: false,
    stockLabel: 'メロンフレッシュ',
    tasteTags: ['fruity', 'citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'godfather',
    name: 'ゴッドファーザー',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'アメリカ',
    price: 1100,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'スコッチアーモンド',
    tasteTags: ['nutty', 'rich', 'smooth'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'godmother',
    name: 'ゴッドマザー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'ウォッカアーモンド',
    tasteTags: ['nutty', 'smooth', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'french-connection',
    name: 'フレンチコネクション',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1200,
    ingredients: [
      { name: 'コニャック', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'コニャックエレガント',
    tasteTags: ['nutty', 'rich', 'elegant'],
    recipeVersion: 1
  }
];
